export function download(dataUri, filename) {
    var link = document.createElement('a')
    link.setAttribute('download', filename)
    link.setAttribute('href', dataUri)
    link.style.display = 'none'
    link.innerHTML = 'Click to download'

    document.body.appendChild(link)

    link.click()

    document.body.removeChild(link)
}
